import React, { memo } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Wrapper from './Wrapper'
import { TextReadWidget } from './TextWidget'


export interface DateWriteWidgetProps {
    id: string
    htmlId?: string
    value: Date|string
    onChange: (id: string, date: Date|[Date|null, Date|null]|null) => void
    title: string
    required?: boolean
    showTime?: boolean
    selectRange?: boolean
    scope?: string
    errors?: string
    placeholder?: string
    hint?: string
    description?: string
}

const DateWriteWidget: React.FC<DateWriteWidgetProps> = memo(({
    id,
    htmlId,
    value,
    onChange,
    title,
    required,
    showTime = false,
    selectRange = false,
    scope,
    errors,
    placeholder = 'Select a date...',
    ...otherProps
}) => {

    const date = value ? new Date(value) : null

    const inputId = `input-${htmlId}`
    const labelId = `label-${htmlId}`
    const descriptionId = `description-${htmlId}`
    const errorId = `error-${htmlId}`
    const hasErrors = errors && errors.length > 0

    return (
        <Wrapper
            title={title}
            required={required}
            errors={errors}
            labelId={labelId}
            descriptionId={descriptionId}
            errorId={errorId}
            {...otherProps}
        >
            <DatePicker
                id={inputId}
                selected={date}
                onChange={(date: Date | [Date | null, Date | null] | null) => (onChange) && onChange(id, date)}
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={100}
                scrollableYearDropdown
                showTimeInput={showTime}
                selectsRange={selectRange as any}
                inline={selectRange}
                placeholderText={placeholder}
                disabled={scope === 'schemaBuilder'}
                className="form-control"
                aria-labelledby={(title || otherProps.hint) ? labelId : undefined}
                aria-invalid={hasErrors ? true : undefined}
                aria-errormessage={hasErrors ? errorId : undefined}
                aria-required={required ? true : undefined}
                calendarClassName="datepicker"
            />
        </Wrapper>
    )
})

export default DateWriteWidget

// ----------------------------------------------------------------------------------------

export interface DateReadWidgetProps {
    value: string
    title: string
    empty?: string
}

const DateReadWidget: React.FC<DateReadWidgetProps> = ({
    value = '',
    ...otherProps
}) => {

    //console.log('DATE', value, {...otherProps})

    return (
        <TextReadWidget
            value={(value) ? moment(value).format('L') : undefined}
            {...otherProps}
        />
    )
}

export {
    DateWriteWidget,
    DateReadWidget
}
